/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserSessionInfoDTO
 */
export interface UserSessionInfoDTO {
    /**
     * 
     * @type {number}
     * @memberof UserSessionInfoDTO
     */
    creationTimeMillis: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserSessionInfoDTO
     */
    newSession?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSessionInfoDTO
     */
    sessionId: string;
}

/**
 * Check if a given object implements the UserSessionInfoDTO interface.
 */
export function instanceOfUserSessionInfoDTO(value: object): value is UserSessionInfoDTO {
    if (!('creationTimeMillis' in value) || value['creationTimeMillis'] === undefined) return false;
    if (!('sessionId' in value) || value['sessionId'] === undefined) return false;
    return true;
}

export function UserSessionInfoDTOFromJSON(json: any): UserSessionInfoDTO {
    return UserSessionInfoDTOFromJSONTyped(json, false);
}

export function UserSessionInfoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserSessionInfoDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'creationTimeMillis': json['creationTimeMillis'],
        'newSession': json['newSession'] == null ? undefined : json['newSession'],
        'sessionId': json['sessionId'],
    };
}

export function UserSessionInfoDTOToJSON(value?: UserSessionInfoDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'creationTimeMillis': value['creationTimeMillis'],
        'newSession': value['newSession'],
        'sessionId': value['sessionId'],
    };
}

